<template>
  <billing-report-panel
    report-key="glosses-reason"
    route="/reports/billing-glosses-reason"
    file-name="glosas-por-motivo.xlsx"
    :columns="columns"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Código',
        'Descrição (Tabela 38)',
        'Grupo',
        'Itens',
        'Guias',
        'Valor glosado',
        'Participação %',
        'Recursado',
        'Recuperado',
        'Recuperação %',
      ],
    };
  },
};
</script>
